import { formatContractEndDate, localFullDate } from "core/formatters";

import { Frequency } from "enums";
import dayjs from "dayjs";

const unlimitedDateFormat = ["31.12.2500", "2500-12-31"];

const getYearFromStringDateTime = (value) => {
    if (value) {
        return dayjs(value).year();
    } else {
        return null;
    }
};

const isDibisibleAndMinTwo = (months, frequency) => months % frequency === 0 && months / frequency >= 2;

const getListOfApplicableFrequenciesByModulo = (numberOfMonths) => {
    const numOfMonthsAsNumber = Number(numberOfMonths);
    const allowedFrequencies = [];

    // Monthly
    if (isDibisibleAndMinTwo(numOfMonthsAsNumber, 1)) {
        allowedFrequencies.push(Frequency.MONTHLY.id);
    }
    // Quarterly
    if (isDibisibleAndMinTwo(numOfMonthsAsNumber, 3)) {
        allowedFrequencies.push(Frequency.QUARTERLY.id);
    }
    // Halfyearly
    if (isDibisibleAndMinTwo(numOfMonthsAsNumber, 6)) {
        allowedFrequencies.push(Frequency.HALFYEARLY.id);
    }
    // Yearly
    if (isDibisibleAndMinTwo(numOfMonthsAsNumber, 12)) {
        allowedFrequencies.push(Frequency.YEARLY.id);
    }

    return allowedFrequencies;
};

const formatToDateWithUnlimited = (toDate, unlimitedMessage) =>
    unlimitedDateFormat.includes(toDate) ? unlimitedMessage : formatContractEndDate(toDate, unlimitedMessage);

const formatCoverageFromTo = (dateValidFrom, dateValidTo, unlimitedMessage) =>
    dateValidFrom || dateValidTo ? `${localFullDate(dateValidFrom)} - ${formatToDateWithUnlimited(dateValidTo, unlimitedMessage)}` : null;

const getMonthYearViewOptions = (minDate, maxDate) => {
    const safeMinDate = minDate ?? dayjs();
    const safeMaxDate = maxDate ?? dayjs();

    return safeMinDate.isSame(safeMaxDate, "year") ? ["month"] : ["month", "year"];
};

export default {
    unlimitedDateFormat,
    // TODO: make date formatting based on Locale
    dateFormat: "DD.MM.YYYY",
    dateFormatWithTime: "DD.MM.YYYY HH:mm",
    dateFormatWithTimeAndSecs: "DD.MM.YYYY HH:mm:ss",
    todayDateAsIsoString: dayjs().format("YYYY-MM-DD"),
    getYearFromStringDateTime,
    formatToDateWithUnlimited,
    formatCoverageFromTo,
    getMonthYearViewOptions,
    getListOfApplicableFrequenciesByModulo,
};
